import { supabase } from "../supaBaseClient";

export const fetchCategories = (onResponse: any) => {
    return async () => {
      try {
        const { data: categories, error } = await supabase.from("categories").select(`
          id,
          name,
          description`);
        if (error) throw error;
        const obj = {
          status: "info",
          data: categories,
        };
        onResponse(obj);
      } catch (error) {
        const obj = {
          status: "error",
          message: "Technical error occurred, contact administrator.",
          error,
        };
        onResponse(obj);
      }
    };
  }; 